<template>
    <v-layout column>
        <v-toolbar class="text-h5 mb-3">
            <v-icon class="mr-3">receipt</v-icon>
            Reservation Review
        </v-toolbar>
        <v-layout align-start>
            <reservation-info
                :currentStep="currentStep"
                :reservedUnit="reservedUnit"
                @toOptions="toOptions"
            />
        </v-layout>
        <v-flex class="subheading mx-4 mb-3">
            Please review all details of this reservation. If needed, you may navigate to back to Reservation Options
            with the above button. If everything looks correct, click "Submit" to process this reservation.
        </v-flex>
    </v-layout>
</template>

<script>
import ReservationInfo from "@/components/reserve-unit/partials/ReservationInfo";

export default {
  props: [
    "currentStep",
    "reservationType",
    "moveInDate",
    "followupDate",
    "reservedUnit"
  ],

  methods: {
    toOptions() {
      this.$emit("toOptions");
    }
  },

  components: {
    ReservationInfo
  }
};
</script>
